import React, { useState } from 'react';
import { Accordion, Checkbox, Icon } from 'semantic-ui-react';
import './nestedAccordionToggle.scss';
import PropTypes from 'prop-types';
import { capitalizeEachWords } from 'utils/capitalize';
import AccordionToggle from '..';

const NestedAccordionToggle = ({
  data,
  toggleBulk,
  handleChange,
  disabled,
  linkTo,
}) => {
  const [isActive, setActive] = useState(false);
  const roleContexts = data?.subItems?.map(item => item.context);

  const disableItem =
    disabled ||
    data?.subItems
      ?.map(item => {
        if (item?.subItems?.length === 0) return false;
        return item?.subItems;
      })
      ?.every(value => value === false);

  return (
    <div className="nested-accordion-toggle">
      <Accordion>
        <div className="accordion-toggle__item">
          <Accordion.Title
            active={isActive}
            onClick={() => setActive(!isActive)}
          >
            <div className="accordion-toggle__main">
              <div className="left">
                <Icon name="dropdown" />
                {capitalizeEachWords(data?.title)}
              </div>
              <div className="right">
                <Checkbox
                  toggle
                  checked={data?.status}
                  disabled={disableItem}
                  onChange={(_, { checked }) =>
                    toggleBulk(
                      checked,
                      [
                        {
                          roles: roleContexts,
                          subItems: data?.subItems?.flatMap(
                            item => item.subItems || [],
                          ),
                        },
                      ],
                      null,
                      'nestedToggle',
                    )
                  }
                />
              </div>
            </div>
          </Accordion.Title>
          <Accordion.Content
            className="nested-accordion-toggle__content"
            active={isActive}
          >
            {data?.subItems?.length > 0 ? (
              data?.category === 'save_admin' ? (
                data?.subItems?.map(item => (
                  <div
                    key={item.context}
                    className="accordion-toggle__content"
                  >
                    <div className="left">
                      {capitalizeEachWords(item?.title)}
                    </div>
                    <div className="right">
                      <Checkbox
                        toggle
                        checked={item?.status}
                        disabled={disabled}
                        onChange={(_, { checked }) =>
                          handleChange(
                            checked,
                            item?.context,
                            null,
                            'toggleRole',
                            item?.title,
                          )
                        }
                      />
                    </div>
                  </div>
                ))
              ) : (
                data?.subItems?.map(item => (
                  <AccordionToggle
                    key={item.context}
                    data={item}
                    handleChange={handleChange}
                    disabled={disabled}
                    linkTo={linkTo}
                  />
                ))
              )
            ) : (
              <Icon name="info circle" />
            )}
          </Accordion.Content>
        </div>
      </Accordion>
    </div>
  );
};

NestedAccordionToggle.defaultProps = {
  disabled: true,
  linkTo: '',
};

NestedAccordionToggle.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    status: PropTypes.bool.isRequired,
    subItems: PropTypes.array.isRequired,
  }).isRequired,
  toggleBulk: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  linkTo: PropTypes.string,
};

export default NestedAccordionToggle;
